import request from '@/utils/requestcors';
import APIURL from '@/api/apiUrl1';
var Web = {
  appid: 'wxd01118f94efb5e3d'
};
export function getAccessToken(code) {
  var data = {
    appid: Web.appid,
    code: code,
    grant_type: 'authorization_code'
  };
  return request.post(APIURL.qr.web.access_token, data);
}
export function refreshAccessToken(token) {
  var data = {
    appid: Web.appid,
    grant_type: 'refresh_token',
    refresh_token: token
  };
  return request.post(APIURL.qr.web.refresh_token, data);
}
export function qrLoginAuth(params) {
  var data = {
    accessToken: params.accessToken,
    openId: params.openId
  };
  return request.post(APIURL.qr.login.auth, data);
}
export function qrBindUser(params) {
  var data = {
    accessToken: params.accessToken,
    openId: params.openId,
    phone: params.phone,
    userId: params.userId
  };
  return request.post(APIURL.qr.web.qr_buiduser, data);
}